import React from "react";

const IconFilledFlag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M16 6.49999C16.0001 6.60385 15.9678 6.70515 15.9076 6.78982C15.8475 6.8745 15.7625 6.93834 15.6644 6.97249L4.5 10.8556L4.5 13.5C4.5 13.6326 4.44732 13.7598 4.35355 13.8535C4.25979 13.9473 4.13261 14 4 14C3.86739 14 3.74021 13.9473 3.64645 13.8535C3.55268 13.7598 3.5 13.6326 3.5 13.5L3.5 2.49999C3.49995 2.42018 3.51901 2.34152 3.55558 2.27058C3.59216 2.19964 3.64518 2.13849 3.71022 2.09223C3.77525 2.04598 3.85042 2.01596 3.92943 2.0047C4.00844 1.99344 4.089 2.00125 4.16438 2.02749L15.6644 6.02749C15.7625 6.06163 15.8475 6.12547 15.9076 6.21015C15.9678 6.29482 16.0001 6.39612 16 6.49999Z"
        fill="#F35625"
      />
    </svg>
  );
};

export default IconFilledFlag;
